import { NgModule } from '@angular/core';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { EmployeeService } from '../../services/employee.service';
import { IEmployee } from '../../model/employee'
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { FormBuilder, FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms'
import * as $ from 'jquery';
@Component({
  selector: 'app-employee-registration',
  templateUrl: './employee-registration.component.html',
  styleUrls: ['./employee-registration.component.scss'],

})
export class EmployeeRegistrationComponent implements OnInit {

  public formSubmitAttempt: boolean;
  public isSlide: boolean = false;
  registertionImage: string;// = require("../../../assets/images/profile.jpg");  
  dob;
  signupForm: FormGroup;
  FirstName: string = "";
  LastName: string = "";
  Email: string = "";
  Password: string = "";
  currencyType: string = "";
  maxDate = {};
  filesToUpload: Array<File> = [];

  imagefile = [];
  private countryCode: string;
  private homecountryCode: string;
  private workcountryCode: string;
  currencyList = [{ value: 'USD', option: 'America (United States) Dollars – USD' },
  { value: 'AFN', option: 'Afghanistan Afghanis – AFN' },
  { value: 'ALL', option: 'Albania Leke – ALL' },
  { value: 'DZD', option: 'Algeria Dinars – DZD' },
  { value: 'ARS', option: 'Argentina Pesos – ARS' },
  { value: 'AUD', option: 'Australia Dollars – AUD' },
  { value: 'ATS', option: 'Austria Schillings – ATS' },

  { value: 'BSD', option: 'Bahamas Dollars – BSD' },
  { value: 'BHD', option: 'Bahrain Dinars – BHD' },
  { value: 'BDT', option: 'Bangladesh Taka – BDT' },
  { value: 'BBD', option: 'Barbados Dollars – BBD' },
  { value: 'BEF', option: 'Belgium Francs – BEF' },
  { value: 'BMD', option: 'Bermuda Dollars – BMD' },

  { value: 'BRL', option: 'Brazil Reais – BRL' },
  { value: 'BGN', option: 'Bulgaria Leva – BGN' },
  { value: 'CAD', option: 'Canada Dollars – CAD' },
  { value: 'XOF', option: 'CFA BCEAO Francs – XOF' },
  { value: 'XAF', option: 'CFA BEAC Francs – XAF' },
  { value: 'CLP', option: 'Chile Pesos – CLP' },

  { value: 'CNY', option: 'China Yuan Renminbi – CNY' },
  { value: 'CNY', option: 'RMB (China Yuan Renminbi) – CNY' },
  { value: 'COP', option: 'Colombia Pesos – COP' },
  { value: 'XPF', option: 'CFP Francs – XPF' },
  { value: 'CRC', option: 'Costa Rica Colones – CRC' },
  { value: 'HRK', option: 'Croatia Kuna – HRK' },

  { value: 'CYP', option: 'Cyprus Pounds – CYP' },
  { value: 'CZK', option: 'Czech Republic Koruny – CZK' },
  { value: 'DKK', option: 'Denmark Kroner – DKK' },
  { value: 'DEM', option: 'Deutsche (Germany) Marks – DEM' },
  { value: 'DOP', option: 'Dominican Republic Pesos – DOP' },
  { value: 'NLG', option: 'Dutch (Netherlands) Guilders – NLG' },

  { value: 'XCD', option: 'Eastern Caribbean Dollars – XCD' },
  { value: 'EGP', option: 'Egypt Pounds – EGP' },
  { value: 'EEK', option: 'Estonia Krooni – EEK' },
  { value: 'EUR', option: 'Euro – EUR' },
  { value: 'FJD', option: 'Fiji Dollars – FJD' },
  { value: 'FIM', option: 'Finland Markkaa – FIM' },

  { value: 'FRF', option: '>France Francs – FRF*' },
  { value: 'DEM', option: 'Germany Deutsche Marks – DEM' },
  { value: 'XAU', option: 'Gold Ounces – XAU' },
  { value: 'GRD', option: 'Greece Drachmae – GRD' },
  { value: 'GTQ', option: 'Guatemalan Quetzal – GTQ' },
  { value: 'NLG', option: 'Holland (Netherlands) Guilders – NLG' },
  { value: 'HKD', option: 'Hong Kong Dollars – HKD' },

  { value: 'HUF', option: 'Hungary Forint – HUF' },
  { value: 'ISK', option: 'Iceland Kronur – ISK' },
  { value: 'XDR', option: 'IMF Special Drawing Right – XDR' },
  { value: 'INR', option: 'India Rupees – INR' },
  { value: 'IDR', option: 'Indonesia Rupiahs – IDR' },
  { value: 'IRR', option: 'Iran Rials – IRR' },

  { value: 'IQD', option: 'Iraq Dinars – IQD' },
  { value: 'IEP', option: 'Ireland Pounds – IEP*' },
  { value: 'ILS', option: 'Israel New Shekels – ILS' },
  { value: 'ITL', option: 'Italy Lire – ITL*' },
  { value: 'JMD', option: 'Jamaica Dollars – JMD' },
  { value: 'JPY', option: 'Japan Yen – JPY' },

  { value: 'JOD', option: 'Jordan Dinars – JOD' },
  { value: 'KES', option: 'Kenya Shillings – KES' },
  { value: 'KRW', option: 'Korea (South) Won – KRW' },
  { value: 'KWD', option: 'Kuwait Dinars – KWD' },
  { value: 'LBP', option: 'Lebanon Pounds – LBP' },
  { value: 'LUF', option: 'Luxembourg Francs – LUF' },

  { value: 'MYR', option: 'Malaysia Ringgits – MYR' },
  { value: 'MTL', option: 'Malta Liri – MTL' },
  { value: 'MUR', option: 'Mauritius Rupees – MUR' },
  { value: 'MXN', option: 'Mexico Pesos – MXN' },
  { value: 'MAD', option: 'Morocco Dirhams – MAD' },
  { value: 'NLG', option: 'Netherlands Guilders – NLG' },

  { value: 'NZD', option: 'New Zealand Dollars – NZD' },
  { value: 'NOK', option: 'Norway Kroner – NOK' },
  { value: 'OMR', option: 'Oman Rials – OMR' },
  { value: 'PKR', option: 'Pakistan Rupees – PKR' },
  { value: 'XPD', option: 'Palladium Ounces – XPD' },
  { value: 'PEN', option: 'Peru Nuevos Soles – PEN' },

  { value: 'PHP', option: 'Philippines Pesos – PHP' },
  { value: 'XPT', option: 'Platinum Ounces – XPT' },
  { value: 'PLN', option: 'Poland Zlotych – PLN' },
  { value: 'PTE', option: 'Portugal Escudos – PTE' },
  { value: 'QAR', option: 'Qatar Riyals – QAR' },
  { value: 'RON', option: 'Romania New Lei – RON' },

  { value: 'ROL', option: 'Romania Lei – ROL' },
  { value: 'RUB', option: 'Russia Rubles – RUB' },
  { value: 'SAR', option: 'Saudi Arabia Riyals – SAR' },
  { value: 'XAG', option: 'Silver Ounces – XAG' },
  { value: 'SGD', option: 'Singapore Dollars – SGD' },
  { value: 'SKK', option: 'Slovakia Koruny – SKK' },

  { value: 'SIT', option: 'Slovenia Tolars – SIT' },
  { value: 'ZAR', option: 'South Africa Rand – ZAR' },
  { value: 'KRW', option: 'South Korea Won – KRW' },
  { value: 'ESP', option: 'Spain Pesetas – ESP' },
  { value: 'XDR', option: 'Special Drawing Rights (IMF) – XDR' },
  { value: 'LKR', option: 'Sri Lanka Rupees – LKR' },

  { value: 'SDD', option: 'Sudan Dinars – SDD' },
  { value: 'SEK', option: 'Sweden Kronor – SEK' },
  { value: 'CHF', option: 'Switzerland Francs – CHF' },
  { value: 'TWD', option: 'Taiwan New Dollars – TWD' },
  { value: 'THB', option: 'Thailand Baht – THB' },
  { value: 'TTT', option: '>Trinidad and Tobago Dollars – TTD' },

  { value: 'TND', option: 'Tunisia Dinars – TND' },
  { value: 'TRY', option: 'Turkey New Lira – TRY' },
  { value: 'AED', option: 'United Arab Emirates Dirhams – AED' },
  { value: 'GBP', option: 'United Kingdom Pounds – GBP' },
  { value: 'USD', option: 'United States Dollars – USD' },
  { value: 'VEB', option: 'Venezuela Bolivares – VEB' },

  { value: 'VND', option: 'Vietnam Dong – VND' },
  { value: 'ZMK', option: 'Zambia Kwacha – ZMK' },]
  constructor(private _employeeService: EmployeeService, private router: Router, private fb: FormBuilder, private cd: ChangeDetectorRef) {
    this.currencyType = "KES";
    this.registertionImage = '../../../assets/images/profile.jpg';
    const current = new Date();
    this.maxDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };
    
    this.signupForm = fb.group({
      firstName: ['', Validators.compose([Validators.required, Validators.maxLength(15), Validators.minLength(1)])],
      lastName: ['', [Validators.required, Validators.maxLength(19)]],
      email: ['', [
        Validators.required,
        Validators.pattern("[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$")
      ]],
      password: ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(30)
      ]],
      mobile: ['', [Validators.required, Validators.maxLength(15), Validators.minLength(1), Validators.pattern("[0-9]+")]],
      home: ['', [Validators.maxLength(15), Validators.minLength(1), Validators.pattern("[0-9]+")]],
      work: ['', [Validators.maxLength(15), Validators.minLength(1), Validators.pattern("[0-9]+")]],
      specialityYear: [],
      degreeDesignation: [],
      currentRegistration: [],
      registrationNumber: [],
      licensingBody: [],
      yearRegistered: [],
      city: [],
      speciality: [],
      confirmPassword: ['', Validators.required],
      dob: [],
      documentfiles: [],
      institution: [],
      specialInterest: [],
      imagefile: [],
      currencyType: [],
      consultationcharges: [],
      countrycode: [],
      homecountrycode: [],
      workcountrycode: []
      ,
    }, { validator: this.checkPasswords })

  }

  checkPasswords(AC: AbstractControl) { // here we have the 'passwords' group
    let password = AC.get('password').value; // to get value in input tag
    let confirmPassword = AC.get('confirmPassword').value; // to get value in input tag
    if (password != confirmPassword) {
      console.log('false');
      AC.get('confirmPassword').setErrors({ MatchPassword: true })
    } else {
      console.log('true');
      return null
    }
  }

  ngOnInit() {

    this.signupForm.controls.currencyType.setValue("Kenya Shillings – KES");
  }

  registerEmployee(employeeForm: FormGroup) {
    this.formSubmitAttempt = true;
    const files: Array<File> = this.filesToUpload;
    if (employeeForm.value.dob) {
      let formateddate = employeeForm.value.dob;
      employeeForm.value.dob = new Date(formateddate.year + '-' + formateddate.month + '-' + formateddate.day)
    }
    else {
      employeeForm.value.dob = null;
    }
    employeeForm.value.usertype = 2;
    employeeForm.value.countrycode = (employeeForm.value.mobile == null || employeeForm.value.mobile == '') ? null : (this.countryCode == null || this.countryCode == '') ? "254" : this.countryCode;
    employeeForm.value.homecountrycode = (employeeForm.value.home == null || employeeForm.value.home == '') ? null : (this.homecountryCode == null || this.homecountryCode == '') ? "254" : this.homecountryCode;
    employeeForm.value.workcountrycode = (employeeForm.value.work == null || employeeForm.value.work == '') ? null : (this.workcountryCode == null || this.workcountryCode == '') ? "254" : this.workcountryCode;
    console.log(employeeForm.value);
    if (employeeForm.invalid) {
      return;
    }
    else {
      this._employeeService.saveEmployee(employeeForm.value, this.imagefile).subscribe(
        data => {
          if (data.returnCode == 0) {
            this.formSubmitAttempt = true;
            alert("Doctor registered Sucessfully")
            this.router.navigate(['employeeList']);
          }
          else {
            alert(data.returnMsg)

          }
        },
        error => {
          // this.alertService.error(error);
          // this.loading = false;         
          alert(error)
          console.log(error)
        });
    }

  }

  selectCurrency(event) {
    this.currencyType = event;
    this.signupForm.controls['currencyType'].setValue(event);
  }
  onFileChange(event) {
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        this.signupForm.get('imagefile').setValue({
          filename: file.name,
          filetype: file.type,
          value: reader.result.split(',')[1],
          fieldname: "imagefile"
        })
      };
    }
  }

  fileChangeEvent(fileInput: any) {
    this.filesToUpload = <Array<File>>fileInput.target.files;

    //this.product.photo = fileInput.target.files[0]['name'];
  }
  onDocumentUpload(event: any) {
    // let fileList: FileList = event.target.files;
    // if (fileList.length > 0) {
    //   let file: File = fileList[0];      
    //   this.docmentfiles=file;      
    // }

    let files = [].slice.call(event.target.files);
    // this.documentfiles=files;

  }


  reset() {
    this.signupForm.reset();
    this.currencyType = "KES";
    this.signupForm.controls.currencyType.setValue("Kenya Shillings – KES");
    this.formSubmitAttempt = false;

  }

  telInputObject(obj) {
    console.log(obj);
    obj.intlTelInput('setCountry', 'ke');
  }

  onCountryChange(obj) {
    this.countryCode = obj.dialCode
    console.log(obj);
  }

  onHomeCountryChange(obj) {
    this.homecountryCode = obj.dialCode
    console.log(obj);
  }
  onWorkCountryChange(obj) {
    this.workcountryCode = obj.dialCode
    console.log(obj);
  }

  getNumber(obj) {
    console.log(obj);
  }

  hasError(obj) {
    console.log(obj)
  }
  sideBarToggle() {
    if (this.isSlide) {
      this.isSlide = false;
    }
    else {
      this.isSlide = true;
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/admin/employee-registration/employee-registration.component.ts